import { JetView } from 'webix-jet';
import { devConfig, profile, countries } from 'config/config';

/**
 * Class representing a table menu view.
 * @extends JetView
 */
export default class tableMenuView extends JetView {
    /**
     * Configures the layout of the view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        var vthis = this; // Reference to the current instance
        countries.unshift({ id: '0', value: _('Todos') }); // Add 'Todos' option to countries

        return {
            rows: [
                {
                    id: 'preloader', // ID for the preloader
                    cols: [
                        {
                            view: 'datatable', // Data table view
                            id: 'datatable', // ID for the data table
                            css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
                            select: true, // Enable row selection
                            scrollY: true, // Enable vertical scrolling
                            columns: [
                                {
                                    id: 'detailTittle', // Column ID
                                    header: '', // Column header
                                    width: 80, // Column width
                                    height: 25, // Column height
                                    tooltip: _('Detalles'), // Tooltip text
                                    template: function (obj) {
                                        // Custom template for rendering
                                        if (obj.State != '1') {
                                            return "<span class='webix_icon wxi-close edit'></span><span class='webix_icon wxi-close torefuse'></span>";
                                        } else {
                                            return '';
                                        }
                                    },
                                },
                                {
                                    id: 'Id', // Column ID
                                    header: _('Id'), // Column header
                                    width: 80, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'Type', // Column ID
                                    header: _('Tipo'), // Column header
                                    width: 150, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'Email', // Column ID
                                    header: _('Email'), // Column header
                                    width: 300, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'Document', // Column ID
                                    header: _('Documento'), // Column header
                                    width: 150, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'DocType', // Column ID
                                    header: _('Tipo Documento'), // Column header
                                    options: [
                                        // Dropdown options for document type
                                        {
                                            id: '1',
                                            value: _('Cédula de ciudadania'),
                                        },
                                        { id: '2', value: _('Pasaporte') },
                                        {
                                            id: '3',
                                            value: _('Cédula extranjería'),
                                        },
                                    ],
                                    width: 150, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'Name', // Column ID
                                    header: _('Nombre'), // Column header
                                    width: 300, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'Phone', // Column ID
                                    header: _('Teléfono'), // Column header
                                    width: 150, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'Partner', // Column ID
                                    header: _('Partner'), // Column header
                                    options: profile.Partners, // Dropdown options for partners
                                    width: 150, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'Country', // Column ID
                                    header: _('País'), // Column header
                                    options: countries, // Dropdown options for countries
                                    width: 150, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'UserCreated', // Column ID
                                    header: _('Usuario creación'), // Column header
                                    width: 150, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'Date', // Column ID
                                    header: _('Fecha creación'), // Column header
                                    width: 150, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'State', // Column ID
                                    header: _('Estado'), // Column header
                                    options: [
                                        // Dropdown options for state
                                        { id: '0', value: _('Activa') },
                                        { id: '1', value: _('Eliminada') },
                                        { id: '2', value: _('Editada') },
                                    ],
                                    width: 150, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'UserModified', // Column ID
                                    header: _('Usuario modificó'), // Column header
                                    width: 150, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'DateModified', // Column ID
                                    header: _('Fecha modificó'), // Column header
                                    width: 150, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'Note', // Column ID
                                    header: _('Nota'), // Column header
                                    width: 300, // Column width
                                    sort: 'int', // Sorting type
                                },
                            ],
                            onClick: {
                                // Event handlers for click events
                                edit: function (euv, id) {
                                    // Edit button click handler
                                    var item = this.getItem(id); // Get the clicked item
                                    vthis.app.callEvent('openEdit', [item]); // Trigger openEdit event
                                },
                                torefuse: function (euv, id) {
                                    // Refuse button click handler
                                    var item = this.getItem(id); // Get the clicked item
                                    vthis.app.callEvent('delete', [item]); // Trigger delete event
                                },
                            },
                            math: true, // Enable math operations
                            loadahead: 0, // Load ahead configuration
                            datafetch: devConfig.getDefaultDataFetch(), // Data fetch configuration
                            pager: 'pagerA', // Pager ID
                            on: {
                                // Event handlers for data table
                                onAfterLoad: function () {
                                    // After load event
                                    this.hideOverlay(); // Hide overlay after loading data
                                },
                            },
                            ready: function () {
                                // Ready event
                                if (!this.count()) {
                                    // Check if there are no data
                                    webix.extend(this, webix.OverlayBox); // Extend with overlay box
                                    this.showOverlay(
                                        // Show overlay with no data message
                                        "<div class='no-data' style='margin:75px; font-size:18px;'>" +
                                            _('No hay datos') +
                                            '</div>',
                                    );
                                }
                            },
                        },
                    ],
                },
            ],
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} grid - The data table instance.
     */
    init(grid) {
        grid = $$('datatable'); // Get the data table instance
        const _ = this.app.getService('locale')._; // Localization service
        var url = devConfig.geturlApi() + 'AdminUser/GetRestrictUsers'; // API URL for fetching restricted users
        const vthis = this; // Reference to the current instance
        var filter = ''; // Filter string for API requests

        // Event listener for filter changes
        this.on(this.app, 'filter', (filterData) => {
            var object = Object.entries(filterData); // Convert filter data to entries
            var string1 = ''; // Initialize filter string
            for (var i = 0; i < object.length; i++) {
                // Iterate through filter entries
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    // Check for non-object and non-empty values
                    if (object[i][0] == 'Datepicker') {
                        // Handle date range filter
                        var date = object[i][1].split(' - '); // Split date range
                        string1 = string1 + '&dateFrom=' + date[0]; // Add start date to filter string
                        string1 = string1 + '&dateTo=' + date[1]; // Add end date to filter string
                    } else {
                        string1 = string1 + '&' + object[i][0] + '=' + object[i][1]; // Add other filters
                    }
                } else {
                    if (typeof object[i][1] === 'object') {
                        // Handle object filters
                        var object2 = Object.entries(object[i][1]); // Convert object to entries
                        for (var j = 0; j < object2.length; j++) {
                            // Iterate through object entries
                            if (object2[j][1] !== null) {
                                // Check for non-null values
                                if (object2[j][0] === 'start') {
                                    // Handle start date
                                    var d = new Date(object2[j][1]); // Create date object
                                    var dateFrom = // Format start date
                                        'dateFrom=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2);
                                    string1 = string1 + '&' + dateFrom; // Add start date to filter string
                                } else {
                                    if (object2[j][0] === 'end') {
                                        // Handle end date
                                        var d = new Date(object2[j][1]); // Create date object
                                        var dateTo = // Format end date
                                            'dateTo=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2);
                                        string1 = string1 + '&' + dateTo; // Add end date to filter string
                                    }
                                }
                            }
                        }
                    }
                }
            }
            filter = string1; // Update filter variable
            grid.clearAll(); // Clear existing data in the grid
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + string1); // Load new data with filters
        });

        // Event listener for creating a new restriction
        this.on(this.app, 'create:button', (filter) => {
            webix
                .ajax()
                .headers({
                    'Content-type': 'application/json', // Set content type for the request
                })
                .post(devConfig.geturlApi() + 'Select/GetRestrictTypes', '', {
                    // Fetch restriction types
                    error: function (text, data, XmlHttpRequest) {
                        webix.message('Error! '); // Show error message
                    },
                    success: function (text, data, XmlHttpRequest) {
                        var resp = JSON.parse(text); // Parse response
                        webix
                            .ui({
                                view: 'window', // Create a new window for the form
                                fullscreen: screen.width < 500 ? true : false, // Fullscreen for small screens
                                width: 500, // Window width
                                head: {
                                    view: 'toolbar', // Toolbar for the window
                                    cols: [
                                        {
                                            view: 'label',
                                            label: _('Crear restricción'), // Label for the window
                                            align: 'center',
                                        },
                                        {
                                            view: 'icon',
                                            icon: 'wxi-close', // Close icon
                                            click: function () {
                                                this.getTopParentView().hide(); // Close the window
                                            },
                                        },
                                    ],
                                },
                                position: 'center', // Center the window
                                modal: true, // Make the window modal
                                body: {
                                    view: 'form', // Form view
                                    id: 'createRestrictUserForm', // Form ID
                                    elements: [
                                        {
                                            margin: 10,
                                            cols: [
                                                {
                                                    view: 'text', // Text input for Email
                                                    labelPosition: 'top',
                                                    label: _('Email'),
                                                    name: 'Email',
                                                    required: false,
                                                },
                                                {
                                                    view: 'combo', // Combo box for Type
                                                    labelPosition: 'top',
                                                    label: _('Tipo'),
                                                    name: 'Type',
                                                    required: false,
                                                    options: resp.Data, // Options from the response
                                                },
                                            ],
                                        },
                                        {
                                            margin: 10,
                                            cols: [
                                                {
                                                    view: 'text', // Text input for Name
                                                    labelPosition: 'top',
                                                    label: _('Nombre'),
                                                    name: 'Name',
                                                    type: 'text',
                                                    required: false,
                                                },
                                                {
                                                    view: 'text', // Text input for Phone
                                                    labelPosition: 'top',
                                                    label: _('Teléfono'),
                                                    name: 'Phone',
                                                    type: 'number',
                                                    required: false,
                                                },
                                            ],
                                        },
                                        {
                                            margin: 10,
                                            cols: [
                                                {
                                                    view: 'combo', // Combo box for Document Type
                                                    labelPosition: 'top',
                                                    label: _('Tipo de documento'),
                                                    name: 'DocType',
                                                    options: [
                                                        {
                                                            id: '1',
                                                            value: _('Cédula de ciudadania'),
                                                        },
                                                        {
                                                            id: '2',
                                                            value: _('Pasaporte'),
                                                        },
                                                        {
                                                            id: '3',
                                                            value: _('Cédula extranjería'),
                                                        },
                                                    ],
                                                    required: false,
                                                },
                                                {
                                                    view: 'text', // Text input for Document
                                                    labelPosition: 'top',
                                                    label: _('Documento'),
                                                    name: 'Document',
                                                    required: false,
                                                },
                                            ],
                                        },
                                        {
                                            margin: 10,
                                            cols: [
                                                {
                                                    view: 'richselect', // Rich select for Partner
                                                    labelPosition: 'top',
                                                    label: _('Partner'),
                                                    name: 'Partner',
                                                    options: profile.Partners, // Options from profile
                                                    required: false,
                                                    value: profile.PartnerSelected, // Default value
                                                    readonly: true, // Make it readonly
                                                },
                                                {
                                                    view: 'richselect', // Rich select for Country
                                                    labelPosition: 'top',
                                                    label: _('País'),
                                                    name: 'Country',
                                                    value: !devConfig.getCountryReport()
                                                        ? '0'
                                                        : profile.Settings.ReportCountry,
                                                    readonly: !devConfig.getCountryReport() ? false : true,
                                                    options: {
                                                        body: {
                                                            template: function (obj) {
                                                                return (
                                                                    "<i class='flags " + obj.icon + "'></i>" + obj.value
                                                                );
                                                            },
                                                            data: countries, // Options for countries
                                                        },
                                                    },
                                                    required: false,
                                                },
                                            ],
                                        },
                                        {
                                            cols: [
                                                {
                                                    view: 'button', // Cancel button
                                                    value: _('Cancelar'),
                                                    click: function () {
                                                        this.getTopParentView().hide(); // Close the window
                                                        $$('createRestrictUserForm').setValues(
                                                            $$('createRestrictUserForm').getCleanValues(), // Reset form values
                                                        );
                                                    },
                                                },
                                                {
                                                    view: 'button', // Save button
                                                    type: 'form',
                                                    value: _('Guardar'),
                                                    click: function ($e) {
                                                        var values = $$('createRestrictUserForm').getValues(); // Get form values
                                                        values.Action = 1; // Set action type
                                                        if (
                                                            $$('createRestrictUserForm').validate() // Validate form
                                                        ) {
                                                            webix
                                                                .ajax()
                                                                .headers({
                                                                    'Content-type': 'application/json', // Set content type
                                                                })
                                                                .post(
                                                                    devConfig.geturlApi() + 'AdminUser/RestrictUser',
                                                                    values, // Send form values
                                                                    {
                                                                        error: function (text, data, XmlHttpRequest) {
                                                                            webix.message(
                                                                                'Error! ', // Show error message
                                                                            );
                                                                        },
                                                                        success: function (text, data, XmlHttpRequest) {
                                                                            text = JSON.parse(
                                                                                text, // Parse response
                                                                            );
                                                                            if (
                                                                                text.HasError // Check for errors
                                                                            ) {
                                                                                webix.message(
                                                                                    'Error: ' + text.AlertMessage, // Show error message
                                                                                );
                                                                            } else {
                                                                                webix.message(
                                                                                    'Restricción creada satisfactoriamente', // Show success message
                                                                                );
                                                                                grid.clearAll(); // Clear grid data
                                                                                grid.load(
                                                                                    url +
                                                                                        '?start=0&count=' +
                                                                                        grid.data.$pagesize +
                                                                                        filter, // Reload grid data
                                                                                );
                                                                                vthis.getTopParentView().hide(); // Close the window
                                                                                $$('createRestrictUserForm').setValues(
                                                                                    $$(
                                                                                        'createRestrictUserForm',
                                                                                    ).getCleanValues(), // Reset form values
                                                                                );
                                                                            }
                                                                        },
                                                                    },
                                                                );
                                                            this.getTopParentView().hide(); // Close the window
                                                        } else {
                                                            webix.message({
                                                                title: _(
                                                                    '¡Error!', // Error title
                                                                ),
                                                                type: 'alert-error',
                                                                text: _(
                                                                    'Completa los campos...', // Error message
                                                                ),
                                                            });
                                                        }
                                                    },
                                                },
                                            ],
                                        },
                                    ],
                                    elementsConfig: {
                                        on: {
                                            onChange: function () {
                                                this.validate(); // Validate form on change
                                            },
                                        },
                                    },
                                },
                            })
                            .show(); // Show the window
                    },
                });
            $$('createRestrictUserForm').clearValidation(); // Clear validation messages
        });

        // Event listener for opening the edit form
        this.on(this.app, 'openEdit', (item) => {
            webix
                .ajax()
                .headers({
                    'Content-type': 'application/json', // Set content type for the request
                })
                .post(devConfig.geturlApi() + 'Select/GetRestrictTypes', '', {
                    // Fetch restriction types
                    error: function (text, data, XmlHttpRequest) {
                        webix.message('Error! '); // Show error message
                    },
                    success: function (text, data, XmlHttpRequest) {
                        var resp = JSON.parse(text); // Parse response
                        webix
                            .ui({
                                view: 'window', // Create a new window for the form
                                id: 'editMenu', // Window ID
                                fullscreen: screen.width < 500 ? true : false, // Fullscreen for small screens
                                width: 500, // Window width
                                head: {
                                    view: 'toolbar', // Toolbar for the window
                                    cols: [
                                        {
                                            view: 'label',
                                            label: _('Editar Menú'), // Label for the window
                                            align: 'center',
                                        },
                                        {
                                            view: 'icon',
                                            icon: 'wxi-close', // Close icon
                                            click: function () {
                                                this.getTopParentView().hide(); // Close the window
                                            },
                                        },
                                    ],
                                },
                                position: 'center', // Center the window
                                modal: true, // Make the window modal
                                body: {
                                    view: 'form', // Form view
                                    id: 'editform', // Form ID
                                    elements: [
                                        {
                                            margin: 10,
                                            cols: [
                                                {
                                                    view: 'text', // Text input for Id
                                                    labelPosition: 'top',
                                                    label: _('Id'),
                                                    name: 'Id',
                                                    hidden: true, // Hide the input
                                                },
                                                {
                                                    view: 'text', // Text input for Email
                                                    labelPosition: 'top',
                                                    label: _('Email'),
                                                    name: 'Email',
                                                    readonly: false,
                                                },
                                                {
                                                    view: 'combo', // Combo box for Type
                                                    labelPosition: 'top',
                                                    label: _('Tipo'),
                                                    name: 'Type',
                                                    readonly: false,
                                                    options: resp.Data, // Options from the response
                                                },
                                            ],
                                        },
                                        {
                                            margin: 10,
                                            cols: [
                                                {
                                                    view: 'text', // Text input for Name
                                                    labelPosition: 'top',
                                                    label: _('Nombre'),
                                                    name: 'Name',
                                                    type: 'text',
                                                    readonly: false,
                                                },
                                                {
                                                    view: 'text', // Text input for Phone
                                                    labelPosition: 'top',
                                                    label: _('Teléfono'),
                                                    name: 'Phone',
                                                    type: 'number',
                                                    readonly: false,
                                                },
                                            ],
                                        },
                                        {
                                            margin: 10,
                                            cols: [
                                                {
                                                    view: 'combo', // Combo box for Document Type
                                                    labelPosition: 'top',
                                                    label: _('Tipo de documento'),
                                                    name: 'DocType',
                                                    options: [
                                                        {
                                                            id: '1',
                                                            value: _('Cédula de ciudadania'),
                                                        },
                                                        {
                                                            id: '2',
                                                            value: _('Pasaporte'),
                                                        },
                                                        {
                                                            id: '3',
                                                            value: _('Cédula extranjería'),
                                                        },
                                                    ],
                                                    readonly: false,
                                                },
                                                {
                                                    view: 'text', // Text input for Document
                                                    labelPosition: 'top',
                                                    label: _('Documento'),
                                                    name: 'Document',
                                                    readonly: false,
                                                },
                                            ],
                                        },
                                        {
                                            margin: 10,
                                            cols: [
                                                {
                                                    view: 'richselect', // Rich select for Partner
                                                    labelPosition: 'top',
                                                    label: _('Partner'),
                                                    name: 'Partner',
                                                    options: profile.Partners, // Options from profile
                                                    readonly: true, // Make it readonly
                                                },
                                                {
                                                    view: 'richselect', // Rich select for Country
                                                    labelPosition: 'top',
                                                    label: _('País'),
                                                    name: 'Country',
                                                    options: {
                                                        body: {
                                                            template: function (obj) {
                                                                return (
                                                                    "<i class='flags " + obj.icon + "'></i>" + obj.value
                                                                );
                                                            },
                                                            data: countries, // Options for countries
                                                        },
                                                    },
                                                    readonly: false,
                                                },
                                            ],
                                        },
                                        {
                                            cols: [
                                                {
                                                    view: 'button', // Cancel button
                                                    value: _('Cancelar'),
                                                    click: function () {
                                                        this.getTopParentView().hide(); // Close the window
                                                        $$('editform').setValues(
                                                            $$('editform').getCleanValues(), // Reset form values
                                                        );
                                                    },
                                                },
                                                {
                                                    view: 'button', // Save button
                                                    type: 'form',
                                                    value: _('Guardar'),
                                                    click: function ($e) {
                                                        var values = $$('editform').getValues(); // Get form values
                                                        values.Action = 2; // Set action type
                                                        if (
                                                            $$('editform').validate() // Validate form
                                                        ) {
                                                            webix
                                                                .ajax()
                                                                .headers({
                                                                    'Content-type': 'application/json', // Set content type
                                                                })
                                                                .post(
                                                                    devConfig.geturlApi() + 'AdminUser/RestrictUser',
                                                                    values, // Send form values
                                                                    {
                                                                        error: function (text, data, XmlHttpRequest) {
                                                                            webix.message(
                                                                                'Error! ', // Show error message
                                                                            );
                                                                        },
                                                                        success: function (text, data, XmlHttpRequest) {
                                                                            text = JSON.parse(
                                                                                text, // Parse response
                                                                            );
                                                                            if (
                                                                                text.HasError // Check for errors
                                                                            ) {
                                                                                webix.message(
                                                                                    'Error: ' + text.AlertMessage, // Show error message
                                                                                );
                                                                            } else {
                                                                                webix.message(
                                                                                    'Restricción editada satisfactoriamente', // Show success message
                                                                                );
                                                                                grid.clearAll(); // Clear grid data
                                                                                grid.load(
                                                                                    url +
                                                                                        '?start=0&count=' +
                                                                                        grid.data.$pagesize +
                                                                                        filter, // Reload grid data
                                                                                );
                                                                                vthis.getTopParentView().hide(); // Close the window
                                                                                $$('editform').setValues(
                                                                                    $$('editform').getCleanValues(), // Reset form values
                                                                                );
                                                                            }
                                                                        },
                                                                    },
                                                                );
                                                            this.getTopParentView().hide(); // Close the window
                                                        } else {
                                                            webix.message({
                                                                title: _(
                                                                    '¡Error!', // Error title
                                                                ),
                                                                type: 'alert-error',
                                                                text: _(
                                                                    'Completa los campos...', // Error message
                                                                ),
                                                            });
                                                        }
                                                    },
                                                },
                                            ],
                                        },
                                    ],
                                },
                            })
                            .show(); // Show the window
                        let itemsEdit = JSON.parse(JSON.stringify(item)); // Clone the item for editing
                        itemsEdit.Type = itemsEdit.TypeId; // Set Type for the form
                        $$('editform').parse(itemsEdit); // Populate the form with item data
                    },
                });
        });

        // Event listener for deleting a restriction
        this.on(this.app, 'delete', (item) => {
            webix
                .ui({
                    view: 'window', // Create a new window for confirmation
                    head: _('Desea eliminar restricción?'), // Confirmation message
                    modal: true, // Make the window modal
                    position: 'center', // Center the window
                    body: {
                        view: 'form', // Form view
                        id: 'windowTransfersForm', // Form ID
                        elements: [
                            {
                                view: 'text', // Text input for Note
                                label: _('Nota'),
                                labelPosition: 'top',
                                name: 'Note',
                                required: true, // Required field
                            },
                            {
                                cols: [
                                    {
                                        view: 'button', // Cancel button
                                        value: _('Cancelar'),
                                        click: function () {
                                            this.getTopParentView().hide(); // Close the window
                                        },
                                    },
                                    {
                                        view: 'button', // Delete button
                                        value: _('Eliminar'),
                                        click: function () {
                                            const vvthis = this; // Reference to the button instance
                                            var values = $$('windowTransfersForm').getValues(); // Get form values
                                            if (
                                                $$('windowTransfersForm').validate() // Validate form
                                            ) {
                                                webix
                                                    .ajax()
                                                    .headers({
                                                        'Content-type': 'application/json', // Set content type
                                                    })
                                                    .post(
                                                        devConfig.geturlApi() + 'AdminUser/RestrictUser',
                                                        {
                                                            Id: item.Id, // ID of the item to delete
                                                            Action: 3, // Action type for delete
                                                            Note: values.Note, // Note from the form
                                                        },
                                                        {
                                                            error: function (text, data, XmlHttpRequest) {
                                                                webix.message(
                                                                    'Error! ', // Show error message
                                                                );
                                                            },
                                                            success: function (text, data, XmlHttpRequest) {
                                                                text = JSON.parse(
                                                                    text, // Parse response
                                                                );
                                                                if (
                                                                    text.HasError // Check for errors
                                                                ) {
                                                                    webix.message(
                                                                        'Error: ' + text.AlertMessage, // Show error message
                                                                    );
                                                                } else {
                                                                    webix.message(
                                                                        'Restricción eliminada satisfactoriamente', // Show success message
                                                                    );
                                                                    grid.clearAll(); // Clear grid data
                                                                    grid.load(
                                                                        url +
                                                                            '?start=0&count=' +
                                                                            grid.data.$pagesize +
                                                                            filter, // Reload grid data
                                                                    );
                                                                    vvthis.getTopParentView().hide(); // Close the window
                                                                }
                                                            },
                                                        },
                                                    );
                                            } else {
                                                webix.message({
                                                    title: _('¡Error!'), // Error title
                                                    type: 'alert-error',
                                                    text: _(
                                                        'Completa los campos...', // Error message
                                                    ),
                                                });
                                            }
                                        },
                                    },
                                ],
                            },
                        ],
                        elementsConfig: {
                            on: {
                                onChange: function () {
                                    this.validate(); // Validate form on change
                                },
                            },
                        },
                    },
                    move: true, // Allow moving the window
                })
                .show(); // Show the window
        });
    }
}

// FILE DOCUMENTED
